import {Component, Input, OnChanges} from '@angular/core';
import {Item} from '../item';
import {CrGetItemService, BinaryRendition} from '../service/cr-getitem.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-pictureloader',
  templateUrl: './picture-loader.component.html',
  styleUrls: ['./picture-loader.component.css']
})
export class PictureLoaderComponent implements OnChanges {
  private static _blankPicture = 'data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=';
  @Input() item: Item;
  @Input() rendition: BinaryRendition;
  imageUrl = this._domSanitizer.bypassSecurityTrustResourceUrl(PictureLoaderComponent._blankPicture);

  constructor( private _crGetItemService: CrGetItemService,
               private _domSanitizer: DomSanitizer) { }

  ngOnChanges() {
    if (this.item.HasPicture()) {
      this._crGetItemService.GetBinary(this.item.remote_content, this.rendition).subscribe((data) => {
        this.CreateImageFromBlob(data);
      });
    }
  }

  private CreateImageFromBlob(image: Blob) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.imageUrl = this._domSanitizer.bypassSecurityTrustResourceUrl(reader.result as string);
    }, false);
    if (image) {
      reader.readAsDataURL(image);
    }
  }
}
